// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__fkehN","opacity-transition":"success_opacity-transition__eSzGj"};